import { render, staticRenderFns } from "./addAddressDialog.vue?vue&type=template&id=4615700f&scoped=true&"
import script from "./addAddressDialog.vue?vue&type=script&lang=js&"
export * from "./addAddressDialog.vue?vue&type=script&lang=js&"
import style0 from "./addAddressDialog.vue?vue&type=style&index=0&id=4615700f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4615700f",
  null
  
)

export default component.exports